/// <amd-module name="Reporting/Common/ICacheableDataQualityQuery" />
import { IVssPageContext } from "VSS/Platform/Context";

export interface ODataPayloadAndWarnings<T> {
    data: T;
    dataQualityWarnings: string[];
}

/**
 * AX centric variant of ICacheableQuery that allows for exposure of data quality warnings in addition to the OData payload.
 */
export interface ICacheableDataQualityQuery<T> {
    getKey(): string;
    runDataQualityAwareQuery(pageContext: IVssPageContext): Promise<ODataPayloadAndWarnings<T>>;
}
